export default __webpack_public_path__ + "static/media/Refined Philtre of Dexterity.1adb159d.jpg";